import React, { Fragment } from 'react';

import facility from 'app/facility';
import {
  Title,
  SubTitle,
  DetailsBox,
  Row,
  PurchaseRow,
  RightValue,
  ValueLine,
  DateSpan,
  MutedText,
  Divider,
} from './styles/WithdrawalStyles';

// Re-export styled components for convenience
export {
  Title,
  SubTitle,
  DetailsBox,
  Row,
  PurchaseRow,
  RightValue,
  ValueLine,
  DateSpan,
  MutedText,
  Divider,
};

type Claim = {
  created: string;
  amount: string;
};

type VoucherDetailsRowsProps = {
  refNum?: string;
  buyerName?: string;
  email?: string;
  created?: string;
  amount?: string;
  currency?: string;
  claims?: Claim[];
};

export const VoucherDetailsRows = ({
  refNum,
  buyerName,
  email,
  created,
  amount,
  currency,
  claims = [],
}: VoucherDetailsRowsProps) => {
  const hasClaims = claims.length > 0;

  return (
    <Fragment>
      <Row>
        <span>{i18n.gettext('Voucher code')}</span>
        <span>{refNum || '-'}</span>
      </Row>

      <Row>
        <span>{i18n.gettext('Name')}</span>
        <span>{buyerName || '-'}</span>
      </Row>

      <Row>
        <span>{i18n.gettext('Email')}</span>
        <span>{email || '-'}</span>
      </Row>

      <PurchaseRow>
        <MutedText>{i18n.gettext('Purchase')}</MutedText>
        <RightValue>
          <ValueLine>
            <DateSpan>{created ? moment(created).format('L') : '-'}</DateSpan>
            <span>{facility.getFormattedPrice(amount, currency)}</span>
          </ValueLine>
        </RightValue>
      </PurchaseRow>

      {hasClaims ? (
        <PurchaseRow>
          <MutedText>{i18n.gettext('Claimed')}</MutedText>
          <RightValue>
            <Fragment>
              {claims.map((claim: Claim, index: number) => (
                <ValueLine key={`${claim.created}-${index}`}>
                  <DateSpan>{moment(claim.created).format('L')}</DateSpan>
                  <span>
                    {/* pass it number as negative to indicate amount redeemed from original voucher value */}
                    {facility.getFormattedPrice(-claim.amount, currency)}
                  </span>
                </ValueLine>
              ))}
            </Fragment>
          </RightValue>
        </PurchaseRow>
      ) : null}
    </Fragment>
  );
};
